import ProfitView from './ProfitView';

export default ProfitView
